import { BrickContext, ActionBrick, registerBrick } from 'olympe';
import lamejs from 'lamejs';

export default class ConvertToMP3 extends ActionBrick {

    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {string} blobUrl
     * @param {function()} forwardEvent
     * @param {function(string)} setBlobUrl
     */
    async update($, [blobUrl], [forwardEvent, setBlobUrl]) {


        let audioBlob = await fetch(blobUrl).then(r => r.blob());
        const audioContext = new (window.AudioContext || window.webkitAudioContext)();
        const arrayBuffer = await audioBlob.arrayBuffer();
        const audioBuffer = await audioContext.decodeAudioData(arrayBuffer);
        const source = audioContext.createBufferSource();
        source.buffer = audioBuffer;

        // Create script processor for MP3 encoding
        const processor = audioContext.createScriptProcessor(2048, 1, 1);

        // Initialize MP3 encoder
        const mp3Encoder = new lamejs.Mp3Encoder(1, audioBuffer.sampleRate, 128);
        const mp3Chunks = [];

        processor.onaudioprocess = (e) => {
            const channel = e.inputBuffer.getChannelData(0);
            const buffer = new Int16Array(channel.length);

            for (let i = 0; i < channel.length; i++) {
                buffer[i] = channel[i] * 0x7FFF;
            }

            const mp3Data = mp3Encoder.encodeBuffer(buffer);
            if (mp3Data.length > 0) {
                mp3Chunks.push(mp3Data);
            }
        };

        // Connect the nodes
        source.connect(processor);
        processor.connect(audioContext.destination);

        // Play the source (needed for processing)
        source.start(0);

        // Wait for processing to finish
        await new Promise(resolve => {
            source.onended = () => {
                const mp3Data = mp3Encoder.flush();
                if (mp3Data.length > 0) {
                    mp3Chunks.push(mp3Data);
                }
                resolve();
            };
        });

        // Create final MP3 Blob
        const newBlob = new Blob(mp3Chunks, { type: 'audio/mp3' });
        setBlobUrl(URL.createObjectURL(newBlob));
        forwardEvent();
    }
}

registerBrick('0194b2bc89bac9755a34', ConvertToMP3);
